module.exports = __webpack_public_path__ + "img/p-camera.ea2e6e49.png";